import React from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';

export const useEnsureRootFoldersVisible = (data: INav[], setExpanded: (ids: string[]) => void) => {
   React.useEffect(() => {
      const ids = [data?.[0]?.id] as string[];
      //   data?.[0]?.child?.forEach((folder) => ids.push(folder.id));
      setExpanded(ids);
   }, [data?.[0]?.id, setExpanded]);
};
